import React from "react";

export const AddressSummarySection = ({ formData }) => {
  console.log("formData Test:", JSON.stringify(formData?.additionalData));

  const selectedTracks = formData?.additionalData?.selectedTracks;
  console.log("Selected Tracks Test:", selectedTracks);

  return (
    <>
      <div className="summary-section">
        <h4>Address Information</h4>
        <div className="summary-row">
          <span className="summary-label">Country:</span>
          <span className="summary-value">{formData.country}</span>
        </div>
        {formData.state && (
          <div className="summary-row">
            <span className="summary-label">State:</span>
            <span className="summary-value">{formData.state}</span>
          </div>
        )}
        {formData.city && (
          <div className="summary-row">
            <span className="summary-label">City:</span>
            <span className="summary-value">{formData.city}</span>
          </div>
        )}
        {formData.pincode && (
          <div className="summary-row">
            <span className="summary-label">Pincode:</span>
            <span className="summary-value">{formData.pincode}</span>
          </div>
        )}
        {formData.address && (
          <div className="summary-row">
            <span className="summary-label">Address:</span>
            <span className="summary-value">{formData.address}</span>
          </div>
        )}

        {selectedTracks && (
          <div className="summary-row">
            <span className="summary-label">Tracks:</span>
            <span className="summary-value">
              {selectedTracks}
              <span
                style={{
                  marginLeft: "8px",
                  padding: "2px 8px",
                  backgroundColor: "#d4edda",
                  color: "#155724",
                  fontSize: "11px",
                  borderRadius: "3px",
                  fontWeight: "600",
                }}
              >
                JSON
              </span>
            </span>
          </div>
        )}
      </div>
    </>
  );
};
